import { externalLink } from "@/routes/_constants/external-link";

import { ExternalLink } from "@/components/ui/button/external-link";

/**
 * CHILLNN サポート「予約フォームやカレンダーを自社サイトに埋め込みたい(サイト埋め込み機能)」
 * https://support.chillnn.com/faq/host/reservation/3c9fffe15c5781cc992dc15f3c08b9e5
 *
 * ベースURLは externalLink.faqSite（dev/prd で自動切替）を使う。
 * パスは Notion ページ ID で構成されるため、日本語タイトルや旧スラッグは使わない。
 */
const SITE_EMBED_GUIDE_URL = `${externalLink.faqSite}/faq/host/reservation/3c9fffe15c5781cc992dc15f3c08b9e5`;

const STUDIO_SITE_URL = "https://studio.design/";

/**
 * サイト埋め込み画面の機能説明。
 * 埋め込み手順の概要と、Studio 連携の推奨をひとつの案内としてまとめる。
 */
export const SiteEmbedDescription = () => {
	return (
		<aside className="rounded-xl border border-zinc-200 bg-white px-5 py-5">
			<div className="space-y-4">
				<p className="text-sm leading-relaxed text-zinc-700">
					お客様の管理している公式ホームページなどのサイトに、埋め込み形式を選んで予約フォームを配置できます。
				</p>
				<p className="text-sm leading-relaxed text-zinc-700">
					埋め込み用タグと表示位置のタグの2つをサイトに埋め込みます。詳しくは
					<ExternalLink
						href={SITE_EMBED_GUIDE_URL}
						text="サイト埋め込みガイド"
						className="text-sm font-medium"
					/>
					をご覧ください。
				</p>
				<p className="border-t border-zinc-200 pt-4 text-sm leading-relaxed text-zinc-700">
					<a
						href={STUDIO_SITE_URL}
						target="_blank"
						rel="noopener noreferrer"
						className="mr-1 inline-flex translate-y-[-1px] items-center align-middle transition-opacity hover:opacity-70"
						aria-label="Studio のサイトを開く"
					>
						<img
							src="/assets/site-embed/studio-logo.svg"
							alt="Studio"
							width={72}
							height={15}
							className="h-3.5 w-auto"
						/>
					</a>
					であれば簡単に連携できますので、推奨しております。対応できない HP
					制作ツールもございますので、不明な場合はお問い合わせください。
				</p>
			</div>
		</aside>
	);
};

SiteEmbedDescription.displayName = "SiteEmbedDescription";
